
const getDecorationTypeLv1List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('1');
    });
    return filteredList;
}

const getDecorationTypeLv2List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('2');
    });
    return filteredList;
}

const getDecorationTypeLv3List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('3');
    });
    return filteredList;
}

const getDecorationTypeLv4List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('4');
    });
    return filteredList;
}

const getDecorationTypeLv5List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('5');
    });
    return filteredList;
}

const getDecorationTypeLv6List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('6');
    });
    return filteredList;
}

const getDecorationTypeLv2FilteredList = (decorationTypeList, lv1Value) => {
    let filteredList = getDecorationTypeLv2List(decorationTypeList).filter(item => {
        return item.parentLv1Id === Number(lv1Value);
    })
    return filteredList
}

const getDecorationTypeLv3FilteredList = (decorationTypeList, lv1Value) => {
    let filteredList = getDecorationTypeLv3List(decorationTypeList).filter(item => {
        return item.parentLv1Id === Number(lv1Value);
    })
    return filteredList
}

const getDecorationTypeLv5FilteredList = (decorationTypeList, lv4Value) => {
    let filteredList = getDecorationTypeLv5List(decorationTypeList).filter(item => {
        return item.thematicParentLv1Id === Number(lv4Value);
    })
    return filteredList
}

const getDecorationTypeLv6FilteredList = (decorationTypeList, lv4Value) => {
    const totalLv6List = getDecorationTypeLv6List(decorationTypeList)
    let filteredList = totalLv6List.filter(item => {
        return item.thematicParentLv1Id === Number(lv4Value);
    })
    if (filteredList.length > 0) {
        return filteredList
    } else {
        return getDecorationTypeLv6WithoutParentList(decorationTypeList)
    }
}

const getDecorationTypeLv6WithoutParentList = (decorationTypeList) => {
    const totalLv6List = getDecorationTypeLv6List(decorationTypeList)
    let filteredList = totalLv6List.filter(item => {
        return item.thematicParentLv1Id === undefined && item.thematicParentLv2Id === undefined;
    })
    return filteredList
}

const getDecorationTypesMap = (decorationTypeList) => {
    let lv1List = getDecorationTypeLv1List(decorationTypeList);
    let lv2List = [];
    let lv3List = [];
    let lv4List = getDecorationTypeLv4List(decorationTypeList);
    let lv5List = [];
    let lv6List = getDecorationTypeLv6WithoutParentList(decorationTypeList);
    let map = [
        { isEnabled: true, typeList: lv1List },
        { isEnabled: false, typeList: lv2List },
        { isEnabled: false, typeList: lv3List },
        { isEnabled: true, typeList: lv4List },
        { isEnabled: false, typeList: lv5List },
        { isEnabled: true, typeList: lv6List },
    ]
    return map;
}

const getUpdatedDecorationTypesMap = (e, currentDecorationTypeMap, decorationTypeList) => {
    let lv1List = currentDecorationTypeMap[0].typeList;
    let lv2List = currentDecorationTypeMap[1].typeList;
    let lv3List = currentDecorationTypeMap[2].typeList;
    let lv4List = currentDecorationTypeMap[3].typeList;
    let lv5List = currentDecorationTypeMap[4].typeList;
    let lv6List = currentDecorationTypeMap[5].typeList;

    let isLv1Selected = currentDecorationTypeMap[0].isEnabled;
    let isLv4Selected = currentDecorationTypeMap[3].isEnabled;

    if (e) {
        e.preventDefault();
        const { name, value } = e.target;
        if (name === 'lv1' && value !== '') {
            isLv1Selected = true
            lv2List = getDecorationTypeLv2FilteredList(decorationTypeList, value)
            lv3List = getDecorationTypeLv3FilteredList(decorationTypeList, value)
        }
        else if (name === 'lv4' && value !== '') {
            isLv4Selected = true
            lv5List = getDecorationTypeLv5FilteredList(decorationTypeList, value)
            lv6List = getDecorationTypeLv6FilteredList(decorationTypeList, value)
        } else if (name === 'lv4' && value === '') {
            lv5List = []
            lv6List = getDecorationTypeLv6WithoutParentList(decorationTypeList)
        }
    }
    let map = [
        { isEnabled: true, typeList: lv1List },
        { isEnabled: isLv1Selected, typeList: lv2List },
        { isEnabled: isLv1Selected, typeList: lv3List },
        { isEnabled: true, typeList: lv4List },
        { isEnabled: isLv4Selected, typeList: lv5List },
        { isEnabled: true, typeList: lv6List },
    ]
    return map;
}

const getDecorationTypesFromSearchPhrase = (decorationTypeList, searchPhrase) => {
    var searchSuggestionList = [];
    decorationTypeList.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    return searchSuggestionList;
}

const getDecorationLowList = (decorationList) => {
    const mappedList = decorationList.map(item => {
        const lowWidth = Math.floor(item.width / 6)
        const lowHeight = Math.floor(item.height / 6)
        return { ...item, width: lowWidth, height: lowHeight };
    })
    return mappedList
}

const getBirthOptionList = (decorationTypeList) => {
    const birthId = 100001;
    let filteredList = [];
    decorationTypeList.forEach((item) => {
        if (item.id === birthId) {
            filteredList.push({ label: 'Todos los cumpleaños', value: item.id.toString() });
        }
        if (item.parentLv1Id === birthId) {
            filteredList.push({ label: item.title, value: item.id.toString() })
        }
    })
    return filteredList;
}


export {
    getDecorationTypeLv1List,
    getDecorationTypeLv2List,
    getDecorationTypesMap,
    getUpdatedDecorationTypesMap,
    getDecorationTypesFromSearchPhrase,
    getDecorationLowList,
    getBirthOptionList
}